import Media from "./Media.interface"

export default interface Template {
    id?: number
    object?: string
    author_id: number
    template_id?: number
    template_name: string
    media?: Media
    media_id?: number
    default: number | boolean
    message_body: string
    type: TemplateType
    created_at?: Date | string
    updated_at?: Date | string
    deleted_at?: Date | string
}

export enum TemplateType {
    invoice = 'invoice',
    message = 'message'
}